import { Box, Button, Grid, Typography, useTheme } from "@material-ui/core";
import React from "react";
import { docIdSide } from "../../modules/kyc/shared/config";
import Text from "./Text";

export const UploadDocIdPictureButton = ({
  currentDocIdSide,
  imageData,
  handleClick,
  handleDelete,
}) => {
  const { palette, customBorderRadius } = useTheme();

  const docIdTitle = Object.keys(docIdSide).find(
    (key) => docIdSide[key] === currentDocIdSide
  );

  return (
    <>
      <Box pb={2}>
        <Typography style={{ color: palette.text.title }} variant="body2">
          <Text tId={docIdTitle} />
        </Typography>
      </Box>
      <Grid
        container
        spacing={1}
        direction="row"
        alignItems="center"
        style={{
          boxShadow: "0px 0px 15px 2px rgba(0, 0, 0, 0.06)",
          borderRadius: customBorderRadius.paper,
          height: 72,
        }}
      >
        {imageData && imageData[currentDocIdSide] ? (
          <>
            <Grid item xs={4} padding={5} style={{ overflow: "hidden" }}>
              <img
                alt={imageData[currentDocIdSide].name}
                src={imageData[currentDocIdSide].result}
                width="auto"
                height="60"
              ></img>
            </Grid>
            <Grid
              item
              xs={6}
              display="flex"
              style={{
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
              }}
            >
              <Typography variant={"caption"}>
                {imageData[currentDocIdSide].name}
              </Typography>
            </Grid>
            <Grid item xs={2}>
              <Button
                style={{ minWidth: "30" }}
                onClick={() => handleDelete(currentDocIdSide)}
              >
                <i
                  className="material-icons"
                  style={{ color: palette.text.secondary }}
                >
                  delete
                </i>
              </Button>
            </Grid>
          </>
        ) : (
          <Button
            fullWidth
            onClick={() => handleClick(currentDocIdSide)}
            style={{ borderRadius: customBorderRadius.paper, height: 72 }}
          >
            <Grid
              container
              item
              xs={3}
              display="flex"
              alignItems="center"
              justifyContent="center"
              style={{
                borderRight: `1px solid ${palette.grey[200]}`,
                height: "50px",
                paddingRight: customBorderRadius.paper,
              }}
            >
              <Grid item>
                <i
                  className="material-icons"
                  style={{ color: palette.text.secondary }}
                >
                  add_a_photo
                </i>
              </Grid>
            </Grid>
            <Grid
              container
              item
              xs={9}
              alignContent="center"
              justifyContent="center"
              style={{ display: "inline-block" }}
            >
              <Grid item>
                <Typography variant={"body2"}>
                  <strong>
                    <Text tId="TAKE_PICTURE" />
                  </strong>
                </Typography>
              </Grid>
              <Grid item>
                <Typography variant={"caption"}>
                  <Text tId="SELECT_FROM_GALLERY" />
                </Typography>
              </Grid>
            </Grid>
          </Button>
        )}
      </Grid>
    </>
  );
};
